'use strict';

angular.module('historyController', [])

.controller('HistoryController', ['$scope', '$rootScope', '$log', '$q','$routeParams','$location',
    function ($scope, $rootScope, $log, $q, $routeParams,$location) {    
    
    //Check auth credentials
    var currentUser = $rootScope.currentUser
    , ekey = currentUser.authdata
    , name = currentUser.name
    , today = moment().unix()
    ;

    $rootScope.header.show = false;
    
    $scope.page = 'timeline';

    $scope.showEvent = function (ref) {
        $location.path('/activity/event/'+ref);
    };

}])

;